import React, { FunctionComponent, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { HStack, Message, Spacing } from '@doveit/bricks';
import { ProcessableContact } from '../../../providers/api/dtos';
import StartFeedbackProcess from '../../containers/start-feedback-process/StartFeedbackProcess';
import { composeURL } from '../../../utils/querystring/querystring';
import GenericPageLayout from '../../../layouts/generic-page-layout/GenericPageLayout';
import { GenericPageLayoutWrapperSize } from '../../../layouts/generic-page-layout/wrapper/GenericPageLayoutWrapper';
import StartLeadProcess from '../../containers/start-lead-process/StartLeadProcess';

type ProcessContext = 'LEADS' | 'SURVEYS' | 'COLD-LEADS';

const CallCenterContactProcessPage: FunctionComponent = () => {
  const navigate = useNavigate();

  const gotoContact = useCallback((context: ProcessContext) => (processableContact?: ProcessableContact) => {
    if (processableContact) {
      const processURL = composeURL(
        `/call-center/contacts/process/${processableContact.id}/${context.toLowerCase()}`,
        processableContact.correlationId ? { correlationId: processableContact.correlationId } : {},
      );
      navigate(processURL);
    }
  }, [navigate]);

  return (
    <GenericPageLayout>
      <GenericPageLayout.Content
        title="Gestisci chiamate"
        wrapperSize={GenericPageLayoutWrapperSize.MEDIUM}
      >
        <Spacing margin={[500, 0]}>
          <Message
            message="Prima di iniziare attiva Aircall"
            boxed
            type="warning"
          />
        </Spacing>

        <HStack gap={300} justifyContent="center">
          <StartLeadProcess
            onNextContact={gotoContact('LEADS')}
          />
          <StartFeedbackProcess
            onNextContact={gotoContact('SURVEYS')}
          />
          <StartLeadProcess
            onNextContact={gotoContact('COLD-LEADS')}
            coldLead
          />
        </HStack>
      </GenericPageLayout.Content>
    </GenericPageLayout>
  );
};

export default CallCenterContactProcessPage;
